import { createFileRoute } from "@tanstack/react-router";
import { projectTasksQuery, stepsQuery, useProject } from "@/api/projects";
import { Page } from "@/components/shell/PageHeader";
import { BriefCard } from "@/components/projects/BriefCard";
import { StepsTimeline } from "@/components/steps/StepsTimeline";

export const Route = createFileRoute("/_app/projects/$projectId/")({
  loader: async ({ context, params }) => {
    const project = await context.queryClient.ensureQueryData({
      queryKey: ["projects", params.projectId],
      queryFn: () => fetch(`/api/projects/${params.projectId}`).then((r) => r.json()),
    });
    await Promise.all([
      context.queryClient.ensureQueryData(stepsQuery(project.id)),
      context.queryClient.ensureQueryData(projectTasksQuery(project.id)),
    ]);
  },
  component: OverviewPage,
});

function OverviewPage() {
  const { projectId } = Route.useParams();
  const project = useProject(projectId);
  if (!project.data) return null;
  return (
    <Page className="space-y-6">
      <BriefCard project={project.data} />
      <StepsTimeline projectId={project.data.id} />
    </Page>
  );
}
